import type { IHomeLoanCompareProductCost } from './HomeLoanCompareProductCost.interface';

export default class HomeLoanCompareProductCost implements IHomeLoanCompareProductCost {
  principal: number;
  interest: number;
  interestWithOffset: number;
  fees: number;
  interestOffsetSavings: number;
  offsetBalance: number;
  monthlyOffsetContribution: number;
  cashback: number;
  total: number;
  timeSaved: string;
  revisedLoanTerm: string;

  static build = (data: IHomeLoanCompareProductCost) => new HomeLoanCompareProductCost(data);
  static blank = () => new HomeLoanCompareProductCost();

  /**
   * Constructor
   * @param {IHomeLoanCompareProductCost} data
   */
  constructor(data?: IHomeLoanCompareProductCost) {
    this.principal = parseFloat(data?.principal || 0);
    this.interest = parseFloat(data?.interest || 0);
    this.interestWithOffset = parseFloat(data?.interestWithOffset || 0);
    this.fees = parseFloat(data?.fees || 0);
    this.interestOffsetSavings = parseFloat(data?.interestOffsetSavings || 0);
    this.offsetBalance = parseFloat(data?.offsetBalance || 0);
    this.monthlyOffsetContribution = parseFloat(data?.monthlyOffsetContribution || 0);
    this.cashback = parseFloat(data?.cashback || 0);
    this.total = parseFloat(data?.total || 0);
    this.timeSaved = data?.timeSaved || '';
    this.revisedLoanTerm = data?.revisedLoanTerm || '';
  }
}
